import {AppState} from '../../store';
import React, {ReactElement} from 'react';
import {percentageFormatter} from 'utils/numberFormatter';

export const getEmissionBackingEstimatePercentage = (
  state: AppState,
): ReactElement | string => {
  const {isLoading, data} = state.emissionBackingEstimate;
  if (isLoading) {
    return 'Estimating backing...';
  } else {
    if (data?.estimatedBacking) {
      return (
        <>
          This will change backing to{' '}
          <span style={{color: 'rgb(252, 216, 97)'}}>
            {percentageFormatter(data.estimatedBacking, 4)}
          </span>
        </>
      );
    } else return 'Failed to estimate backing';
  }
};
